<template>
  <div class="home">
    <!-- <span @click="geta">123</span> -->
    <!-- <el-button @click="daochu" type="primary">翻译导出</el-button> -->
    <el-container>
      <el-aside style="max-width: 240px; width: auto">
        <Aside />
      </el-aside>
      <el-container>
        <el-header height="72px">

          <Head ref="Head" />
        </el-header>
        <el-main>
          <router-view class="routerView" />
          <!-- 往上 -->
          <el-backtop :bottom="70" target=".el-main" :right="10">
            <div class="up">
              <i class="el-icon-arrow-up"></i>
            </div>
          </el-backtop>
          <!-- 往下 -->
          <div class="bottom" @click="toBottom">
            <i class="el-icon-arrow-down"></i>
          </div>
        </el-main>
      </el-container>
    </el-container>

  </div>
</template>
<script>
import Head from '../components/home/Head'
import Aside from '../components/home/aside'
import messagezh from '../utlis/multilingual/zh'
import messageja from '../utlis/multilingual/ja'
import { mapState } from 'vuex'
import config from '../api/config'

// 企业微信授权白名单账号，无需强制授权
const WX_WORK_AUTH_WHITELIST = [
  104, 13, 1452, 348, 351, 374, 405, 406, 408, 409,
  542, 578, 579, 580, 586, 590, 1017, 1098, 1099, 1294, 1464,1454
]

export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data() {
    return {

      tableData: [],
      japanUserRoleInfo: JSON.parse(localStorage.getItem('japanUserRoleInfo'))
    }
  },
  components: {
    Head,
    Aside,
  },
  computed: {
    title() {
      let routeName = this.$route.name
      let leftMenu = this.$store.state.leftMenu
      let title = '首页'
      leftMenu.forEach(item => {
        item.child_menus.forEach(items => {
          if (items.route == routeName) {
            title = items.name
          }
        })
      })
      return title
    },
    userInfo() {
      if (localStorage.getItem("japanUserRoleInfo")) {
        return JSON.parse(localStorage.getItem("japanUserRoleInfo"));
      } else {
        return {};
      }
    }
  },
  created() {
    document.cookie = `japan_access_token=${localStorage.getItem('japan_access_token')} ${this.japanUserRoleInfo.id}`;

  },
  mounted() {
    // 企业微信授权弹窗仅在正式站启用，白名单账号无需强制授权
    if (config.isProduction && this.userInfo.admin_wx_work == null && !WX_WORK_AUTH_WHITELIST.includes(Number(this.userInfo.id))) {
      this.$refs.Head.$refs.wechatAuthorization.openDialog()
    }
  },
  methods: {
    // 到底部
    toBottom() {
      var osTop = 0
      let timer = setInterval(function () {
        var elMain = document.querySelector('.el-main')
        var elMainHeight = elMain.scrollHeight
        let ispeed = Math.floor(elMainHeight / 5);
        osTop += ispeed
        elMain.scrollTo(0, osTop)
        if (osTop >= elMainHeight) {
          clearInterval(timer);
        }
      }, 50);
    },
    //   翻译导出
    daochu() {
      this.tableData = []
      for (let key in messagezh.message) {
        this.tableData.push({
          name: key,
          zh: messagezh.message[key],
          translate: '',
        })
      }
      for (let key in messageja.message) {
        for (let j = 0; j <= this.tableData.length; j++) {
          this.tableData[j].index = j + 1
          if (key == this.tableData[j].name) {
            this.tableData[j].translate = messageja.message[key]
            break
          }
        }
      }
      this.tableData.forEach(item => {
        if (item.zh == item.translate) {
          item.translate = ''
        }
      })
      this.tableData = this.tableData.filter(item => item.translate == '')
      this.handleExportExcel()
    },
    geta() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../utlis/Export2Excel')
        const tHeader = ['路由', '页面', 'icon']
        const filterVal = ['path']
        const list = JSON.parse(localStorage.getItem('list'))
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '路由')
      })
    },
    // excel导出
    handleExportExcel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../utlis/Export2Excel')
        const tHeader = ['NO', '中文', '翻译']
        const filterVal = ['index', 'zh', 'translate']
        const list = this.tableData //把data里的tableData存到list
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '翻译列表')
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../css/mixin';

.up {
  height: 100%;
  width: 100%;
  background-color: #b4272d;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 50%;
}

.bottom {
  height: 40px;
  width: 40px;
  background-color: #b4272d;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: fixed;
  right: 10px;
  bottom: 20px;
  cursor: pointer;

  i {
    font-size: 20px;
    color: #fff;
  }
}

/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

// /deep/.is-checked {
//   .el-checkbox__inner {
//     background-color: #32323c;
//   }
// }
.home {
  @include wh(100%, calc(100%));
  margin: 0 auto;
  position: relative;
  min-width: 1850px;

  .el-button {
    position: absolute;
    top: 10px;
    right: 100px;
    z-index: 999;
  }

  header {
    background-color: #fff;
    height: 60px;
    padding: 20px 0 0 30px;
    box-sizing: border-box;
  }

  /deep/ .el-tabs__nav-wrap::after {
    display: none !important;
  }

  .el-container {
    height: 100%;

    overflow: hidden;
    padding: 0;

    .el-header {
      color: #333;
      padding: 0;
    }

    .el-aside {
      height: 100%;
      background-color: #32323c;
      color: #333;
      text-align: center;
    }

    .el-main {
      height: 100%;
      background-color: $el-main-bgc;
      color: #333;
      padding: 0 !important;

      .routerView {
        background: #fff;
        min-height: calc(100vh - 72px);
        //height: 100%;
        padding: 24px;
        box-sizing: border-box;
      }
    }
  }
}

/deep/.el-table-column--selection {
  .cell {
    width: 50px !important;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}

/deep/.el-table__header {
  .el-table-column--selection {
    .cell {
      width: 50px !important;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }
}
</style>
